var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"presentation_view_wrp"},[_c('div',{staticClass:"covid_19_popup",staticStyle:{"opacity":"0"}}),_c('iframe',{attrs:{"src":"https://oddvega-public-content.s3.ca-central-1.amazonaws.com/LYMPHOMAP_PPT.pdf","frameBorder":"0","scrolling":"auto","height":"100%","width":"100%"}})])
}]

export { render, staticRenderFns }